<script>
export let label;
export let legend = null;
</script>

<button type="submit">{label}</button>
{#if legend}
  <span class="legend">{legend}</span>
{/if}

<style>
button {
  background-color: #00b5b0;
  width: 100%;
  display: block;
  text-align: center;
  color: #ffffff;
  border: 0;
  padding: 2rem;
  font-size: 2rem;
  transition: 0.3s;
  cursor: pointer;
  font-weight: 500;
}

button:hover {
  background-color: #068d89;
}

button:disabled {
  background-color: #666666;
  pointer-events: none;
  cursor: not-allowed;
}

.legend {
  font-style: italic;
  margin-top: 0.7rem;
  font-size: 1.3rem;
  opacity: 0.8;
  display: block;
  text-align: center;
  width: 100%;
}
</style>